export default "__VITE_ASSET__C0Eg7$rK__"